import { styled } from '@aibi-ui/core';
import { CloseOutlined } from '@ant-design/icons';

const StyledClearIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  cursor: pointer;
  svg {
    font-size: 8px;
  }
  &:hover {
    color: #5687ff;
    background: #eef3ff;
  }
`;

const ClearIcon = props => (
  <StyledClearIcon {...props}>
    <CloseOutlined />
  </StyledClearIcon>
);

export default ClearIcon;
